export default [
  {
    id: 1,
    name: '普通用户'
  },
  {
    id: 3,
    name: '后台管理员'
  },
  {
    id: 4,
    name: '超级管理员'
  },
  {
    id: 10,
    name: '客服'
  },
  {
    id: 11,
    name: '公司内部运维角色'
  },
  {
    id: 9999,
    name: '默认后台角色'
  }
]